<template>
    <div class="image-upload-form card p-4 mb-4">
        <h4 class="card-title">Subir Nueva Imagen (Sin Autenticación Interna)</h4>
        <b-alert v-if="uploadError" show variant="danger" dismissible @dismissed="uploadError = null">
            {{ uploadError }}
        </b-alert>
        <b-alert v-if="uploadSuccess" show variant="success" dismissible @dismissed="uploadSuccess = null">
            {{ uploadSuccess }}
        </b-alert>

        <form @submit.prevent="handleUpload">
            <div class="mb-3">
                <label for="imageFile" class="form-label">Seleccionar Imagen:</label>
                <input class="form-control" type="file" id="imageFile" @change="handleFileChange" accept="image/*" required>
            </div>
            <div class="d-flex justify-content-end">
                <b-button variant="secondary" @click="cancelUpload" class="me-2">Cancelar</b-button>
                <b-button type="submit" variant="primary" :disabled="uploading">
                    <b-spinner small v-if="uploading"></b-spinner> Subir Imagen
                </b-button>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue'; // Añadir defineProps
import { BAlert, BButton, BSpinner } from 'bootstrap-vue-next';
import { uploadImage } from '../../../services/imageService.js';

const emit = defineEmits(['image-uploaded', 'cancel-upload']);

const selectedFile = ref(null);
const uploading = ref(false);
const uploadError = ref(null);
const uploadSuccess = ref(null);

const props = defineProps({
    // adminPassword ya no es necesario aquí
});

function handleFileChange(event) {
    selectedFile.value = event.target.files[0];
    uploadError.value = null;
    uploadSuccess.value = null;
}

async function handleUpload() {
    if (!selectedFile.value) {
        uploadError.value = "Por favor, selecciona un archivo.";
        return;
    }

    uploading.value = true;
    uploadError.value = null;
    uploadSuccess.value = null;
 
     try {
        const token = localStorage.getItem('jwt_token');
        if (!token) {
            uploadError.value = "No autenticado. Por favor, inicia sesión de nuevo.";
            uploading.value = false;
            return;
        }
         await uploadImage(selectedFile.value, token); // Usar el token
         uploadSuccess.value = "Imagen subida con éxito.";
         const fileInput = document.getElementById('imageFile');
         if (fileInput) {
             fileInput.value = '';
         }
         selectedFile.value = null;
         emit('image-uploaded');
     } catch (err) {
         console.error("Error al subir imagen:", err);
         uploadError.value = `Error al subir imagen: ${err.message}`;
     } finally {
         uploading.value = false;
     }
}

function cancelUpload() {
    const fileInput = document.getElementById('imageFile');
    if (fileInput) {
        fileInput.value = '';
    }
    selectedFile.value = null;
    uploadError.value = null;
    uploadSuccess.value = null;
    emit('cancel-upload');
}

</script>

<style scoped>
.image-upload-form {
    /* Estilos específicos para el formulario de subida */
}
</style>